module.exports = __webpack_public_path__ + "img/cita.b724e73e.svg";